import PracticeExamsContainer from './PracticeExamsContainer';

export default { PracticeExamsContainer };
